<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">Review Deck URL</v-card-title>
      <v-card-text class="mt-3 body-2">
        <v-text-field
          v-model="reviewDeckURL"
          type="text"
          hide-details
          @input="$v.reviewDeckURL.$touch()"
          :error-messages="reviewDeckURL"
          @blur="$v.reviewDeckURL.$touch()"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()" :disabled="$v.reviewDeckURL.$invalid">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
// import userAPIs from '../User/userAPIs';
// import config from '@/config';
// import moment from 'moment'
import Loading from 'vue-loading-overlay';
export default {
  name: 'ReviewDeckUrlModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    item: Object,
    dateCol: String
  },
  validations: {
    reviewDeckURL: {
      required
    }
  },
  data () {
    return {
      isLoading: false,
      reviewDeckURL: ''
    }
  },
  async mounted() {
  },
  computed: {
    reviewDeckURLErrors() {
      const errors = [];
      if (!this.$v.reviewDeckURL.$dirty) return errors;
      !this.$v.reviewDeckURL.required && errors.push('This field is required.');
      return errors;
    }
  },
  watch: {
    value: function(newValue) {
      this.reviewDeckURL = ''
    }
  },
  methods: {
    save() {
      this.item[this.dateCol].reviewDateURL = this.reviewDeckURL
      this.$emit('saveClicked', this.item)
      this.$emit('input')
    },
    close() {
      this.item[this.dateCol].status = false
      this.$emit('closeClicked', this.item)
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// ReviewDeckUrlModal.vue?636de93c